module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/node_modules/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = polyfills